import React, { useEffect, useRef, useState } from 'react';
import styles from './Tooltip.module.scss';

function Tooltip({ x, y, text, className = '' }) {
  const tooltipRef = useRef(null);
  const [position, setPosition] = useState({ top: y, left: x });

  // Adjust position to stay within viewport
  useEffect(() => {
    if (!tooltipRef.current) return;

    const tooltip = tooltipRef.current;
    const rect = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Calculate new position to stay within viewport
    let newTop = y + 12;
    let newLeft = x + 12;

    // Check right edge
    if (newLeft + rect.width > viewportWidth) {
      newLeft = x - rect.width - 12;
    }

    // Check bottom edge
    if (newTop + rect.height > viewportHeight) {
      newTop = y - rect.height - 12;
    }

    // Check left edge (after potential adjustment)
    if (newLeft < 0) {
      newLeft = 12;
    }

    // Check top edge (after potential adjustment)
    if (newTop < 0) {
      newTop = 12;
    }

    setPosition({ top: newTop, left: newLeft });
  }, [x, y]);

  if (!text) return null;

  return (
    <div 
      ref={tooltipRef}
      className={`${styles.tooltip} ${className}`}
      style={{
        top: position.top,
        left: position.left,
      }}
    >
      {text}
    </div>
  );
}

export default Tooltip; 